<template>
  <BCIconBanner>
    <div class="blog-banner__content col-12 text-center w-100">
      <h2 class="mb-16 text-center">
        {{ $label('blog.becomeMemberBanner.title') }}
      </h2>
      <p class="text-large mb-24 text-center">
        {{ $label('blog.becomeMemberBanner.subtitle') }}
      </p>
      <NuxtLink to="/aanmelden">
        <BaseButton variant="call-to-action" class="mb-24 mb-md-32">
          {{ $label('blog.becomeMemberBanner.btnText') }}
        </BaseButton>
      </NuxtLink>
      <p class="mb-0 text-center">
        {{ $label('blog.becomeMemberBanner.bottomText') }}
      </p>
    </div>
  </BCIconBanner>
</template>

<script>
import BCIconBanner from './BCIconBanner'

export default {
  components: {
    BCIconBanner,
  },
}
</script>
